import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { asTitle } from "utils/Utils";
import { AddEvent, Event } from "utils/history/Event";

import { UserRights } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import UserRightInsertRow from "core/trajectory/access/UserRightInsertRow";
import UserRightRow from "core/trajectory/access/UserRightRow";

export interface UserRightsTableProps {
	users: UserRights[];
	roles: string[];
	editable: boolean;

	onChange: (event: Event) => void;
}

function UserRightsTable(props: UserRightsTableProps): JSX.Element {
	const { t } = useTranslation();

	const onInsertUser = useCallback(
		(user: string, roles: string[]): void => {
			const userRights = { user, roles };
			props.onChange(
				new AddEvent(`/users/${props.users.length}`, userRights)
			);
		},
		[props.users, props.onChange]
	);

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>{asTitle(t("user"))}</TableCell>
					<TableCell sx={{ width: 300 }}>
						{asTitle(t("role_other"))}
					</TableCell>
					<TableCell sx={{ width: 60 }} padding="none" />
				</TableRow>
			</TableHead>
			<TableBody>
				{props.users.map((user, index) => (
					<UserRightRow
						key={user.user}
						index={index}
						userRights={user}
						roles={props.roles}
						editable={props.editable}
						onChange={props.onChange}
					/>
				))}
				{props.editable && (
					<UserRightInsertRow
						existingUsers={props.users.map(user => user.user)}
						roles={props.roles}
						onInsert={onInsertUser}
					/>
				)}
			</TableBody>
		</Table>
	);
}

export default UserRightsTable;
